import { render } from "./Toggle.vue?vue&type=template&id=34a12998"
import script from "./Toggle.vue?vue&type=script&lang=ts"
export * from "./Toggle.vue?vue&type=script&lang=ts"
script.render = render

export default script